export default __webpack_public_path__ + "static/media/car-fixing-2.b0b8c738.jpg";